import { Accessor } from "solid-js";
import { HomeOnecardRouteData } from "../data/home_onecard_route_data";

export function useHomeOnecard(routeData: Accessor<HomeOnecardRouteData>) {
  const getGridCols = () => {
    const brandsCount = routeData()?.brands?.length ?? 0;
    if (brandsCount === 1) {
      return { "grid-cols-1 !max-w-[500px]": true };
    }
    if (brandsCount === 2) {
      return { "grid-cols-1 sm:grid-cols-2 !max-w-[600px]": true };
    }
    if (brandsCount === 3) {
      return { "grid-cols-1 sm:grid-cols-3": true };
    }
    if (brandsCount === 4) {
      return { "grid-cols-1 sm:grid-cols-2 !max-w-[600px]": true };
    }
    // 5 - 8 brands: 3-column grid on larger screens
    return { "grid-cols-1 sm:grid-cols-3": true };
  };

  return {
    getGridCols,
  };
}
